const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: 'کد سفارشی را در نقاط مشخصی از جریان احراز هویت اجرا کنید تا رفتار Logto را گسترش دهید.',
    status: {
        not_configured: 'پیکربندی نشده',
        configured: 'پیکربندی شده',
        enabled: 'فعال',
        disabled: 'غیرفعال',
    },
    types: {
        post_first_factor_verification: {
            name: 'پس از تأیید عامل اول',
            description: 'پس از ناموفق بودن تأیید رمز عبور محلی هنگام ورود، منطق سفارشی را اجرا کنید.',
        },
        post_sign_in: {
            name: 'پس از ورود',
            description: 'پس از ورود موفق کاربر، منطق سفارشی را اجرا کنید.',
        },
    },
    data_source_tab: 'منبع داده',
    test_tab: 'زمینه آزمایش',
    settings_tab: 'تنظیمات',
    event_data: {
        title: 'بار رویداد',
        subtitle: 'از پارامتر ورودی `event` برای داده‌های رویداد احراز هویت استفاده کنید.',
    },
    result_data: {
        title: 'نتیجه اقدام',
        subtitle: 'یک شیء نتیجه برگردانید که Logto برای این نوع اقدام آن را بفهمد.',
    },
    environment_variables: {
        title: 'تنظیم متغیرهای محیطی',
        subtitle: 'از متغیرهای محیطی برای ذخیره اطلاعات حساس استفاده کنید.',
        input_field_title: 'افزودن متغیرهای محیطی',
        sample_code: 'دسترسی به متغیرهای محیطی در هندلر اقدام. مثال:',
    },
    fetch_external_data: {
        title: 'دریافت داده خارجی',
        subtitle: 'از اسکریپت اقدام خود APIهای خارجی را فراخوانی کنید.',
        description: 'از تابع `fetch` برای فراخوانی APIهای خارجی خود استفاده کنید و داده‌ها را در نتیجه اقدام بگنجانید. مثال:',
    },
    settings: {
        title: 'تنظیمات',
        subtitle: 'کنترل کنید که آیا اقدام فعال است و خطاهای زمان اجرا چگونه مدیریت می‌شوند.',
        enabled: {
            title: 'فعال‌سازی اقدام',
            description: 'وقتی رویداد احراز هویت فعال می‌شود این اسکریپت را اجرا کنید.',
        },
        on_execution_error: {
            title: 'در صورت خطای اسکریپت',
            description: 'انتخاب کنید Logto هنگام شکست اسکریپت در زمان اجرا چگونه رفتار کند.',
            block: 'مسدود کردن جریان احراز هویت',
            allow: 'اجازه دادن به ادامه جریان احراز هویت',
            post_first_factor_description: 'وقتی این اسکریپت شکست می‌خورد، Logto همیشه اعتبارنامه‌های نامعتبر را رد می‌کند تا تأیید رمز عبور دور زده نشود.',
        },
    },
    test_context: {
        subtitle: 'بار رویداد ساختگی مورد استفاده هنگام اجرای آزمایش‌ها را تنظیم کنید.',
        input_field_title: 'JSON نمونه رویداد',
    },
    script: {
        title: 'اسکریپت',
        restore: 'بازیابی پیش‌فرض‌ها',
        restored: 'بازیابی شد',
    },
    tester: {
        run_button: 'اجرای آزمایش',
        result_title: 'نتیجه آزمایش',
    },
    form_error: {
        invalid_json: 'قالب JSON نامعتبر',
    },
    security_warning: {
        title: 'هشدار امنیتی',
        description: 'این اقدام فقط پس از ناموفق بودن تأیید رمز عبور محلی اجرا می‌شود. تنها پس از تأیید مستقل رمز عبور ارسال‌شده، `passwordVerified: true` را برگردانید. کاربران provision‌شده توسط این اقدام از محدودیت‌های مخصوص ثبت‌نام عبور می‌کنند؛ از جمله فهرست مسدودسازی ایمیل، دامنه فقط SSO، حالت غیرفعال‌بودن ثبت‌نام، و بررسی‌های پروفایل اجباری ثبت‌نام. نوشتن پروفایل و رمز عبور کاربران موجود نیز پیش از تکمیل MFA انجام می‌شود.',
    },
    delete_modal_title: 'حذف اقدام',
    delete_modal_content: 'آیا مطمئن هستید که می‌خواهید این اقدام را حذف کنید؟ جریان احراز هویت دیگر این اسکریپت را اجرا نخواهد کرد.',
    deleted: 'اقدام حذف شد',
    created: 'اقدام ایجاد شد',
    saved: 'اقدام ذخیره شد',
};
export default Object.freeze(actions);
